export const FOLLOW_UP_COMPLAINS_TRANSLATE = {
    followUpComplaints: {
        title: "Ingrese el número de protocolo para seguir su denuncia",
        form: {
            fields: {
                protocol: {
                    label: "Número de protocolo",
                    placeholder: "Ingrese aquí el número de protocolo"
                }
            }
        }
    }
}
